import { memo } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { getDayAndMonthFromUTC, createDataset } from "utils/formatters";
import { RegionChartProps } from "constants/types";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const RegionChart = memo(
  ({ examMLResultDoubleKnee, title }: RegionChartProps) => {
    if (window.location.search.includes("isFreeForm=true")) {
      return <></>;
    }
    const options = {
      plugins: {
        title: {
          display: false,
          text: "Chart.js Bar Chart - Stacked",
        },
        legend: {
          display: false,
        },
        tooltip: {
          displayColors: false, //to not show bar color in the tooltip
        },
      },
      responsive: true,
      interaction: {
        intersect: false,
      },
      scales: {
        x: {
          stacked: true,
        },
      },
    };
    const plugins = [ChartDataLabels];

    const datasets = () => {
      let datasets = [];
      let dateAndStacks: { dayAndMonth: string | undefined; stack: number }[] =
        [];
      let stack = 1;
      if (examMLResultDoubleKnee.length > 0) {
        let allExamMLResultSorted = examMLResultDoubleKnee
          .slice()
          .sort((a: any, b: any) => {
            return (
              new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
            );
          });

        for (let i = 0; i < allExamMLResultSorted.length; i++) {
          let dayAndMonth = getDayAndMonthFromUTC(
            allExamMLResultSorted[i].createdAt
          );
          if (
            dateAndStacks.length > 0 &&
            dayAndMonth == dateAndStacks[dateAndStacks.length - 1].dayAndMonth
          ) {
            stack = dateAndStacks[dateAndStacks.length - 1].stack += 2;
          } else {
            stack = 1;
          }
          if (allExamMLResultSorted[i].leftMinValue > 0) {
            datasets.push(
              createDataset(
                "Left Knee Min Value",
                dayAndMonth,
                allExamMLResultSorted[i],
                "#FFFFFF",
                stack.toString(),
                ""
              )
            );
          } else if (allExamMLResultSorted[i].leftMinValue < 0) {
            datasets.push(
              createDataset(
                "Left Knee Min Value",
                dayAndMonth,
                allExamMLResultSorted[i],
                "#C83D57",
                stack.toString(),
                ""
              )
            );
          }
          if (allExamMLResultSorted[i].leftMaxValue > 0) {
            datasets.push(
              createDataset(
                "Left Knee Max Value",
                dayAndMonth,
                allExamMLResultSorted[i],
                "#52B788",
                stack.toString(),
                "L"
              )
            );
          } else if (allExamMLResultSorted[i].leftMaxValue < 0) {
            datasets.push(
              createDataset(
                "Left Knee Max Value",
                dayAndMonth,
                allExamMLResultSorted[i],
                "#FFFFFF",
                stack.toString(),
                "L"
              )
            );
          }
          dateAndStacks.push({ dayAndMonth, stack });

          if (
            dateAndStacks.length > 0 &&
            dayAndMonth == dateAndStacks[dateAndStacks.length - 1].dayAndMonth
          ) {
            stack = dateAndStacks[dateAndStacks.length - 1].stack += 2;
          } else {
            stack = 2;
          }
          if (examMLResultDoubleKnee[i].rightMinValue > 0) {
            datasets.push(
              createDataset(
                "Right Knee Min Value",
                dayAndMonth,
                examMLResultDoubleKnee[i],
                "#FFFFFF",
                stack.toString(),
                ""
              )
            );
          } else if (examMLResultDoubleKnee[i].rightMinValue < 0) {
            datasets.push(
              createDataset(
                "Right Knee Min Value",
                dayAndMonth,
                examMLResultDoubleKnee[i],
                "#C83D57",
                stack.toString(),
                ""
              )
            );
          }
          if (examMLResultDoubleKnee[i].rightMaxValue > 0) {
            datasets.push(
              createDataset(
                "Right Knee Max Value",
                dayAndMonth,
                examMLResultDoubleKnee[i],
                "#52B788",
                stack.toString(),
                "R"
              )
            );
          } else if (examMLResultDoubleKnee[i].rightMaxValue < 0) {
            datasets.push(
              createDataset(
                "Right Knee Max Value",
                dayAndMonth,
                examMLResultDoubleKnee[i],
                "#FFFFFF",
                stack.toString(),
                "R"
              )
            );
          }
        }
      }
      return datasets;
    };

    const data = {
      datasets: datasets(),
    };

    return (
      <>
        <div className="flex">
          <strong className="text-[18px] mr-[46px] capitalize ">
            {title} Progress Chart
          </strong>
          <div className="h-[10px] w-[10px] bg-[#52B788] rounded-[6px] self-center mr-[4px]"></div>
          Varus
          <div className="h-[10px] w-[10px] bg-[#C83D57] rounded-[6px] self-center mr-[4px] ml-[16px]"></div>
          Valgus
        </div>
        {/* @ts-ignore: Unreachable code error */}
        {data.datasets.length > 0 ? (
          <Bar options={options} plugins={plugins} data={data} />
        ) : (
          <div
            style={{
              width: "100%",
              height: 200,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            No data available
          </div>
        )}
      </>
    );
  }
);
